import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { sessionApi } from '../services/api';
import { useSession } from '../context/SessionContext';
import Button from '../components/Button';
import ErrorDisplay from '../components/ui/ErrorDisplay';
import PageTransition from '../components/PageTransition';

const JoinSessionPage: React.FC = () => {
  const { sessionId } = useParams<{ sessionId: string }>();
  const navigate = useNavigate();
  const { setParticipantId } = useSession();
  const [nickname, setNickname] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleJoin = async () => {
    if (!nickname.trim()) {
      setError('Введите ваше имя');
      return;
    }
    if (!sessionId) return;

    setLoading(true);
    setError('');

    try {
      const data = await sessionApi.join(sessionId, nickname.trim());
      setParticipantId(data.participantId);
      localStorage.setItem(`session_${sessionId}_pid`, data.participantId);
      navigate(`/session/${sessionId}/lobby`);
    } catch (err) {
      setError('Ошибка при подключении к сессии');
    } finally {
      setLoading(false);
    }
  };

  return (
    <PageTransition className="min-h-screen bg-gradient-to-br from-orange-50 to-red-50 flex items-center justify-center px-4">
      <div className="max-w-sm w-full text-center">
        <div className="w-16 h-16 rounded-full bg-orange-100 flex items-center justify-center mx-auto mb-4">
          <svg className="w-8 h-8 text-orange-500" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M23 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" />
          </svg>
        </div>
        <h1 className="text-2xl font-bold text-gray-900 mb-2">
          Swipe<span className="text-orange-500">Eat</span>
        </h1>
        <p className="text-gray-500 mb-8">
          Вас пригласили выбирать ресторан вместе!
        </p>

        <div className="space-y-4">
          <input
            type="text"
            value={nickname}
            onChange={(e) => setNickname(e.target.value)}
            placeholder="Ваше имя..."
            maxLength={30}
            className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:ring-2 focus:ring-orange-500 focus:border-transparent outline-none text-center"
            onKeyDown={(e) => e.key === 'Enter' && handleJoin()}
          />

          <ErrorDisplay error={error} />

          <Button size="lg" fullWidth disabled={loading} onClick={handleJoin}>
            {loading ? 'Подключение...' : 'Присоединиться'}
          </Button>
        </div>
      </div>
    </PageTransition>
  );
};

export default JoinSessionPage;
